import React, { useState } from "react";
import { withRouter } from "react-router-dom";

// Ant Design
import { Button, Col, Select, Input, Row, Typography } from "antd";

const { Option } = Select;
const { Title } = Typography;

const FilterBar = props => {
  const { refetchAudienceDemographs, loadingAudienceDemographs } = props;

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectChange = selectedItems => {
    setSelectedItems(selectedItems);
  };

  const handlePublish = () => {
    // TODO: Implement publish functionality in the next PR
    console.log("Publishing selected items:", selectedItems);
  };

  return (
    <Row
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "65px",
      }}
    >
      <Col span={5}>
        <Title level={5}>Audience Library</Title>
      </Col>
      <Col
        span={19}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Row gutter={14}>
          <Col>
            <Select disabled={true} style={{ border: "none", width: "150px" }}>
              <Option value="ARCHIVED">Archived</Option>
              <Option value="PUBLISHED">Published</Option>
            </Select>
          </Col>
          <Col>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Select
                style={{ minWidth: 200, marginRight: 0 }} // Adjusted width
                placeholder="Select an option"
                onChange={handleSelectChange}
                disabled={true}
              >
                <Option value="LIQUIDM">Liquid M</Option>
              </Select>
              <Button type="primary" onClick={handlePublish}>
                Publish
              </Button>
            </div>
          </Col>
          <Col>
            <Input.Search
              placeholder={"Search Audience Library"}
              loading={loadingAudienceDemographs}
              style={{ width: "20em" }}
              onSearch={search => {
                refetchAudienceDemographs({ nameSearch: search });
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default withRouter(FilterBar);
